var map = {
	"./android-studio.svg": "9e21",
	"./blender.svg": "c6fb",
	"./css.svg": "3032",
	"./git.svg": "5dc4",
	"./html.svg": "da0c",
	"./jetpack.svg": "81c8",
	"./jupyter.svg": "453f",
	"./kotlin.svg": "38e7",
	"./linux.svg": "e10d",
	"./mssql.svg": "79db",
	"./mvvm.svg": "4825",
	"./mysql.svg": "a90b",
	"./nfc.svg": "9213",
	"./php.svg": "a8be",
	"./python.svg": "c3b6",
	"./raspberrypi.svg": "f7ae",
	"./tailwindcss.svg": "9f2b",
	"./unreal-engine.svg": "505a",
	"./vbnet.svg": "7052",
	"./vue.svg": "0b4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6d4";